import { getI18n } from 'react-i18next';

export const VALIDATION_AUCTIONEER_DATA_TEMPLATE_INVALID_ID = 'validation.auctioneerDataTemplate.invalidId';
export const VALIDATION_AUCTIONEER_DATA_TEMPLATE_NO_NAME_OR_ID = 'validation.auctioneerDataTemplate.noTemplateNameOrId';
export const VALIDATION_AUCTIONEER_DATA_TEMPLATE_BOTH_NAME_AND_ID = 'validation.auctioneerDataTemplate.bothTemplateNameAndId';
export const VALIDATION_AUCTIONEER_DATA_TEMPLATE_INVALID_NAME_LENGTH = 'validation.auctioneerDataTemplate.invalidNameLength';
export const VALIDATION_AUCTIONEER_DATA_TEMPLATE_EMPTY_TEMPLATE_ITEMS = 'validation.auctioneerDataTemplate.emptyTemplateItems';
export const ERROR_AUCTIONEER_DATA_TEMPLATE_NOT_FOUND = 'auctioneerDataTemplate.notFound';

export const createAuctioneerDataTemplateErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_AUCTIONEER_DATA_TEMPLATE_INVALID_ID:
            result = i18n.t('auctioneer-data-templates.error.auctioneer-data-template-invalid-id');
            break;
        case VALIDATION_AUCTIONEER_DATA_TEMPLATE_NO_NAME_OR_ID:
            result = i18n.t('auctioneer-data-templates.error.auctioneer-data-template-no-name-or-id');
            break;
        case VALIDATION_AUCTIONEER_DATA_TEMPLATE_BOTH_NAME_AND_ID:
            result = i18n.t('auctioneer-data-templates.error.auctioneer-data-template-both-name-and-id');
            break;
        case VALIDATION_AUCTIONEER_DATA_TEMPLATE_INVALID_NAME_LENGTH:
            result = i18n.t('auctioneer-data-templates.error.auctioneer-data-template-invalid-name-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTIONEER_DATA_TEMPLATE_EMPTY_TEMPLATE_ITEMS:
            result = i18n.t('auctioneer-data-templates.error.auctioneer-data-template-empty-template-items');
            break;
        case ERROR_AUCTIONEER_DATA_TEMPLATE_NOT_FOUND:
            result = i18n.t('auctioneer-data-templates.error.auctioneer-data-template-not-found');
            break;
        default:
            result = undefined;
    }
    return result;
};
